import type {AuthUser} from '@/matic/types/auth';

export function canManageFiles(user: AuthUser): boolean {
  return user.role !== 'basic';
}

export function canManageCategories(user: AuthUser): boolean {
  return user.role === 'quality' || user.role === 'admin';
}

export function canHardDelete(user: AuthUser): boolean {
  return user.role === 'quality' || user.role === 'admin';
}
